import { createBrowserOnlyLazyComponent } from '@dbh/react-lazy';

var index = createBrowserOnlyLazyComponent(()=>import('./component-90bee611.js'/* webpackChunkName: "dbh.price-updated-entry-content" */));

export { index as default };
